import { useEffect, useState } from 'react'

import { Box, Tabs } from '@chakra-ui/react'
import { PanelType } from '@editor/config/constants'
import { INFO_PANEL_PADDING } from '@editor/config/styles'
import { toggleCollapsedPanel } from '@editor/pages/projects/blueprint-editor/store/blueprintEditor'
import CollapsePanel from '@editor/pages/projects/editor/infoPanels/components/CollapsePanel'
import { RootState, useAppDispatch } from '@editor/store/app'
import { useSelector } from 'react-redux'

import BlueprintSettings from './BlueprintSettings'
import PCDSettings from './PCDSettings'

const SettingsPanel = () => {
  // Store
  const dispatch = useAppDispatch()
  const selectedBlueprint = useSelector((state: RootState) => state.blueprint.editor.selectedBlueprint)
  const isCollapsed = useSelector((state: RootState) => state.blueprint.editor.collapsedPanel).includes(
    PanelType.Settings,
  )
  // State
  const [tabValue, setTabValue] = useState('pcd')

  /**
   * If there's no selected blueprint, switch over to the PCD settings tab.
   */
  useEffect(() => {
    if (!selectedBlueprint) {
      setTabValue('pcd')
    } else {
      setTabValue('blueprint')
    }
  }, [selectedBlueprint])

  return (
    <Box data-testid="settings-panel" className="panel">
      <CollapsePanel
        title="設定"
        onChange={() => dispatch(toggleCollapsedPanel(PanelType.Settings))}
        isCollapsed={isCollapsed}
      >
        <Tabs.Root
          value={tabValue}
          onValueChange={(e) => setTabValue(e.value)}
          w="100%"
          pb={INFO_PANEL_PADDING - 1}
          size="sm"
          variant="panel"
        >
          <Tabs.List>
            <Tabs.Trigger value="pcd">表示設定</Tabs.Trigger>
            {!selectedBlueprint ? null : <Tabs.Trigger value="blueprint">設計図面設定</Tabs.Trigger>}
          </Tabs.List>

          <Tabs.Content value="pcd">
            <PCDSettings />
          </Tabs.Content>
          <Tabs.Content value="blueprint" px={0}>
            <BlueprintSettings />
          </Tabs.Content>
        </Tabs.Root>
      </CollapsePanel>
    </Box>
  )
}

export default SettingsPanel
